import React, { useState, useEffect, useRef } from "react";

import {
  Col,
  Row,
  Divider,
  Input,
  Form,
  Button,
  Card,
  InputNumber,
  Checkbox,
  Modal,
  Select,
  Space,
} from "antd";
import { BarsOutlined, FallOutlined } from "@ant-design/icons";
import Cleave from "cleave.js/react";

import RequestHandler from "util/RequestHandler";
import { defaultValidateMessages } from "../Forms/Helper";
import { odata } from "../Filters/Helper";
import { ColumnHelper } from "util/TableHelper";
import PosCommissionTable from "./PosCommissionTable";
import PosSelectableInstallmentTable from "./PosSelectableInstallmentTable";
import PosCollectionAmountSummary from "./PosCollectionAmountSummary";
import PhoneInput from "react-phone-input-2";
import {
  useUrlIframeBankIds,
  emailRequiredBankIds,
} from "../../util/B2BHelper";
import BannerSlider from "../../components/Banner/BannerSlider";

const { TextArea } = Input;
const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 24,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 24,
    },
  },
};
const PosCollectionPage = (props) => {
  const [loading, setLoading] = useState(false);
  const [creditCardType, setCreditCardType] = useState("");
  const [form] = Form.useForm();
  const [paymentModal, setPaymentModal] = useState({
    visible: false,
    source: null,
  });
  const [availableProviders, setAvailableProviders] = useState({
    loading: true,
    data: [],
  });
  const [firmsBalance, setFirmsBalance] = useState({
    loading: true,
    data: [],
  });
  const [activeFirmBalance, setActiveFirmBalance] = useState(0);
  const [availableInstallments, setAvailableInstallments] = useState({
    loading: false,
    data: [1],
  });
  const [activeProviderId, setActiveProviderId] = useState();
  const [activeFirmId, setActiveFirmId] = useState();
  const [currencyCodes, setCurrencyCodes] = useState(["TRY", "USD", "EUR"]);
  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });
  const [commissionOptions, setCommissionOptions] = useState({
    loading: true,
    data: {
      useCommissionsForAvailableInstallment: false,
      useFirmGroupCodeForMaxInstallment: false,
      isSelectableInstallmentTable: false,
      posCollectionDescription: null,
      commissions: [],
    },
  });
  const [activeAmount, setActiveAmount] = useState(0);
  const [payableAmount, setPayableAmount] = useState(0);
  const [radioValue, setRadioValue] = useState();
  const iframeRef = useRef();

  const [confidentialAgreement, setconfidentialAgreement] = useState(
    "/gizlilik-ve-guvenlik-politikasi.pdf"
  );
  const [salesAgreement, setSalesAgreement] = useState("/tuketici-haklari.pdf");
  const [isUseCreditCardBinCheck, setIsUseCreditCardBinCheck] = useState();
  const [usePosCommissionTable, setUsePosCommissionTable] = useState(false);
  const [
    commissionOptionsForBinCheckUsage,
    setCommissionOptionsForBinCheckUsage,
  ] = useState({
    loading: true,
    data: {
      useCommissionsForAvailableInstallment: false,
      useFirmGroupCodeForMaxInstallment: false,
      isSelectableInstallmentTable: false,
      posCollectionDescription: null,
      commissions: [],
    },
  });
  const [urlIframe, setUrlIframe] = useState(false);
  const [requestBin, setRequestBin] = useState(true);
  const [useAdditionalInformation, setUseAdditionalInformation] =
    useState(false);
  const [bankIdFromBinCheckResult, setBankIdFromBinCheckResult] =
    useState(null);
  const [cardKindFromBinCheckResult, setCardKindFromBinCheckResult] =
    useState(null);
  const [b2bFilePath, setB2bFilePath] = useState();
  const [activeCommissionRate, setActiveCommissionRate] = useState(0.0);
  const [selectedCommission, setSelectedCommission] = useState(null);
  const [emailRequired, setEmailRequired] = useState(false);
  const [isUseB2BCurrencyExChange, setIsUseB2BCurrencyExChange] =
    useState(false);
  const [currencyExchangeRates, setCurrencyExchangeRates] = useState({
    data: {
      usdAmount: null,
      euroAmount: null,
      tlAmount: null,
    },
  });

  const [activeCurrency, setActiveCurrency] = useState("TRY");
  const [paymentMethodList, setPaymentMethodList] = useState({
    loading: true,
    data: [],
  });
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState();
  const [
    isUseB2BViewCurrencyExchangeRate,
    setIsUseB2BViewCurrencyExchangeRate,
  ] = useState(false);

  const [viewCurrencyExchangeRates, setViewCurrencyExchangeRates] = useState({
    data: {
      usd: null,
      euro: null,
    },
  });

  const [isUsePreAuth, setIsUsePreAuth] = useState(false);
  const [preAuthBankIds, setPreAuthBankIds] = useState([]);
  const [activeBankId, setActiveBankId] = useState();
  const [tenantScreenSettings, setTenantScreenSettings] = useState({
    b2BShowCampaignButton: true,
    b2BFirmSelectRequired: false,
    b2BViewUsdOnCurrencyDropDown: true,
    b2BViewEuroOnCurrencyDropDown: true,
    b2BCustomerInformationVisibility: true,
    b2BMobilePhoneVisibility: false,
    b2BTcknVisibility: false,
  });

  useEffect(() => {
    if (
      props.match.params.firmId !== undefined &&
      props.match.params.firmId !== null &&
      props.match.params.firmId !== ""
    ) {
      RequestHandler.get(
        `/Firm/FirmDropdown?$select=id,firmBranchNumber,name&$filter=id eq ${props.match.params.firmId}`
      ).then((res) => {
        setFirmSelect({ data: res, loading: false });
      });
      setActiveFirmId(props.match.params.firmId);
    }

    getAvailableProviders();
    getFirmsBalance();
    getTenantScreenSettings();

    RequestHandler.get(
      "/Tenant/GetById/" + localStorage.getItem("tenantId")
    ).then((response) => {
      if (response.confidentialityAgreementPath) {
        setconfidentialAgreement(response.confidentialityAgreementPath);
      }

      if (response.salesAgreementPath) {
        setSalesAgreement(response.salesAgreementPath);
      }
    });

    RequestHandler.get("/TenantParameter/GetByTenant").then((response) => {
      if (response) {
        setUseAdditionalInformation(
          response.isPosTransactionUseAdditionalField
        );
        setIsUseCreditCardBinCheck(response.isUseCreditCardBinCheck);
        setB2bFilePath(response.b2BFilePath);
        setIsUseB2BCurrencyExChange(response.isUseB2BCurrencyExChange);
        setIsUseB2BViewCurrencyExchangeRate(
          response.b2BViewCurrencyExchangeRate
        );
        if (!response.isUseCreditCardBinCheck) {
          getCommissionOptions();
        } else {
          setUsePosCommissionTable(true);
          RequestHandler.get(
            `/PosCollection/CommissionOptions?requestForNoPayment=true`
          ).then((response) => {
            if (response.success) {
              setCommissionOptionsForBinCheckUsage({
                data: response.data,
                loading: false,
              });
            } else {
              setCommissionOptionsForBinCheckUsage({
                ...commissionOptions,
                loading: false,
              });
            }
          });
        }
        if (response.isPosTransactionUseAdditionalField) {
          RequestHandler.get(`/PaymentMethod`).then((response) => {
            setPaymentMethodList({
              data: response.value,
              loading: false,
            });
          });
        }

        if (response.b2BViewCurrencyExchangeRate) {
          RequestHandler.get(`/Currency`).then((response) => {
            setViewCurrencyExchangeRates({
              data: {
                usd: response?.value?.find((item) => item.code === "USD")
                  ?.dailyValue,
                euro: response?.value?.find((item) => item.code === "EUR")
                  ?.dailyValue,
              },
            });
          });
        }
      } else {
        getCommissionOptions();
      }
    });

    RequestHandler.get(
      `/PosCollectionBankInfo?$filter=isUsePreAuth eq true and isActive eq true&$select=bankId`
    ).then((response) => {
      if (response) {
        setPreAuthBankIds(response.value.map((item) => item.bankId));
      }
    });
  }, []);

  useEffect(() => {
    if (!activeProviderId) return;
    let currencies = ["TRY", "USD", "EUR"];

    //Param Pos
    if (activeProviderId === 889) {
      currencies = ["TRY"];
    }

    setCurrencyCodes(currencies);

    if (!tenantScreenSettings.b2BViewUsdOnCurrencyDropDown) {
      setCurrencyCodes((prev) => prev.filter((x) => x !== "USD"));
    }
    if (!tenantScreenSettings.b2BViewEuroOnCurrencyDropDown) {
      setCurrencyCodes((prev) => prev.filter((x) => x !== "EUR"));
    }

    setFieldsValue({ currencyCode: currencies[0] });

    if (!commissionOptions.data.isSelectableInstallmentTable) {
      getAvailableInstallments(
        activeProviderId,
        activeFirmId,
        commissionOptions.data.commissions
      );
    }
  }, [activeProviderId]);

  useEffect(() => {
    const firmId = activeFirmId === null ? undefined : activeFirmId;
    if (!commissionOptions.data.isSelectableInstallmentTable) {
      getAvailableInstallments(
        activeProviderId,
        activeFirmId,
        commissionOptions.data.commissions
      );
    }

    //taksit tablosundan banka ve taksit seçmede bayi değişince seçimi sıfırlıyoruz.
    clearRadioValue();

    if (isUseCreditCardBinCheck != undefined && !isUseCreditCardBinCheck) {
      getCommissionOptions(
        firmId,
        undefined,
        undefined,
        undefined,
        selectedPaymentMethod?.paymentSetId
      );
    }

    form.resetFields(["cardNumber"]);
  }, [activeFirmId, isUseCreditCardBinCheck, selectedPaymentMethod]);

  useEffect(() => {
    if (props.data) {
      setFieldsValue(props.data);
    }
  }, [props.data]);

  useEffect(() => {
    if (isNaN(payableAmount)) {
      setPayableAmount(0);
    } else {
      setPayableAmount(payableAmount);
    }
  }, [payableAmount]);

  const getAvailableProviders = () => {
    RequestHandler.get("/PosCollection/AvailableProviders").then((response) => {
      if (response.success) {
        setAvailableProviders({
          data: response.data,
          loading: false,
        });
        setActiveProviderId(response.data?.at(0)?.id);
      } else {
        setAvailableProviders({ ...availableProviders, loading: false });
      }
    });
  };

  const getCommissionOptions = (
    firmId,
    bankIdFromBinCheck,
    cardKindFromBinCheck,
    amount,
    paymentSetId
  ) => {
    let queryString = firmId ? `?firmId=${firmId}` : "";

    if (amount !== null && amount !== undefined) {
      queryString += `${queryString ? "&" : "?"}amount=${amount}`;
    }

    if (bankIdFromBinCheck && firmId) {
      queryString += `&bankIdFromBinCheck=${bankIdFromBinCheck}&cardKindFromBinCheck=${cardKindFromBinCheck}`;
    } else if (bankIdFromBinCheck && queryString != "") {
      queryString += `&bankIdFromBinCheck=${bankIdFromBinCheck}&cardKindFromBinCheck=${cardKindFromBinCheck}`;
    } else if (bankIdFromBinCheck && queryString == "") {
      queryString += `?bankIdFromBinCheck=${bankIdFromBinCheck}&cardKindFromBinCheck=${cardKindFromBinCheck}`;
    }

    if (paymentSetId) {
      queryString += `${queryString ? "&" : "?"}paymentSetId=${paymentSetId}`;
    }

    RequestHandler.get(`/PosCollection/CommissionOptions${queryString}`).then(
      (response) => {
        if (response.success) {
          setCommissionOptions({
            data: response.data,
            loading: false,
          });
          clearRadioValue();
        } else {
          setCommissionOptions({ ...commissionOptions, loading: false });
        }
      }
    );
  };

  const getFirmsBalance = () => {
    RequestHandler.get("/PosCollection/GetFirmsBalanceFromErp").then(
      (response) => {
        if (Array.isArray(response)) {
          setFirmsBalance({
            data: response,
            loading: false,
          });
        } else {
          setFirmsBalance({ ...firmsBalance, loading: false });
        }
      }
    );
  };

  const getAvailableInstallments = (bankId, firmId, commissions) => {
    setAvailableInstallments({ ...availableInstallments, loading: true });

    var selectedCommission =
      commissions !== undefined && commissions !== null
        ? commissions.find((x) => x.bankId == bankId)
        : null;

    setSelectedCommission(selectedCommission);
    RequestHandler.post(
      `/PosCollection/AvailableInstallments`,
      {
        bankId: bankId,
        firmId: firmId,
        commissions: selectedCommission,
        isUseCreditCardBinCheck: isUseCreditCardBinCheck,
      },
      false
    ).then((response) => {
      if (!response.success) {
        setAvailableInstallments({ ...availableInstallments, loading: false });
        setFieldsValue({ installmentCount: 1 });
        return;
      }

      const { installments, defaultInstallment } = response.data;
      setAvailableInstallments({ data: installments, loading: false });

      setFieldsValue({ installmentCount: defaultInstallment });
    });
  };

  const onFirmSearch = (value) => {
    if (value.length >= 2) {
      setFirmSelect({ ...firmSelect, loading: true });

      RequestHandler.get(
        `/Firm/FirmDropdown?$select=id,firmBranchNumber,name&$filter=${odata.contains(
          "name",
          value
        )} or ${odata.contains("firmBranchNumber", value)}`
      ).then((res) => {
        setFirmSelect({ data: res, loading: false });
      });
    } else {
      setFirmSelect({ data: [], loading: false });
    }
  };

  const onFinish = (values) => {
    let expireMonth, expireYear;

    if (values.expiration) {
      [expireMonth, expireYear] = values.expiration.split("/");
    }

    if (commissionOptions.data.isSelectableInstallmentTable) {
      var bankIdCommissionIdWithInstallment =
        values.bankIdInstallment.split("/");
      values.bankId = bankIdCommissionIdWithInstallment[0];
      values.installmentCount = bankIdCommissionIdWithInstallment[3];
      values.cardType = bankIdCommissionIdWithInstallment[2];
      values.posCollectionCommissionDefinitionId =
        bankIdCommissionIdWithInstallment[1];
    } else {
      if (selectedCommission != null) {
        values.posCollectionCommissionDefinitionId = selectedCommission?.id;
      }
    }

    RequestHandler.post(
      `/PosCollection/SalesRequest`,
      {
        holderName: values.holderName,
        cardNumber: values.cardNumber,
        cvv: values.cvv,
        expireMonth: expireMonth,
        expireYear: expireYear,
        amount: payableAmount,
        currencyCode: values.currencyCode,
        bankId: values.bankId,
        firmId: values.firmId,
        installmentCount: values.installmentCount,
        customerInformation: values.customerInformation,
        description: values.description,
        cardType: values.cardType,
        tckn: values.tckn,
        contractNumber: values.contractNumber,
        branchCode: values.branchCode,
        memberNumber: values.memberNumber,
        netAmount: values.amount,
        posCollectionCommissionDefinitionId:
          values.posCollectionCommissionDefinitionId,
        customerEmail: values.email,
        paymentMethod: selectedPaymentMethod?.name,
        paymentSetId: selectedPaymentMethod?.paymentSetId,
        isUsePreAuth: isUsePreAuth,
        mobilePhone: values.mobilePhone,
      },
      false
    ).then((response) => {
      setLoading(false);
      if (response.success) {
        if (
          useUrlIframeBankIds?.includes(values.bankId) &&
          (response?.data?.startsWith("http://") ||
            response?.data?.startsWith("https://"))
        ) {
          setUrlIframe(true);
        }
        //fill html
        setPaymentModal({ visible: true, source: response.data });
        form.resetFields();
        setFieldsValue({
          bankId: values.bankId,
          firmId: values.firmId,
        });

        if (props.onSuccess) props.onSuccess();
      }
    });
  };

  const onChangeActiveProvider = (value) => {
    setActiveProviderId(value);
  };

  const onFinishFailed = () => {
    setLoading(false);
  };

  const onChangeRadio = (radioVal, values) => {
    setRadioValue(radioVal);
    setFieldsValue(values);
  };

  const clearRadioValue = () => {
    setRadioValue(null);
    form.setFieldsValue({ bankIdInstallment: null });
  };

  const setFieldsValue = (values) => {
    const currentValues = form.getFieldsValue();
    const newValues = { ...currentValues, ...values };
    form.setFieldsValue(newValues);

    onFormValuesChange(values, newValues);
  };

  const onFormValuesChange = (changedValues, allValues) => {
    var activeCommissions = commissionOptions.data.commissions.find(
      (x) => x.bankId === allValues.bankId && !x.isVisaMasterCard
    );
    var installmentCount = allValues.installmentCount;
    if (allValues.bankIdInstallment) {
      var bankIdCommissionIdWithInstallment =
        allValues.bankIdInstallment.split("/");

      activeCommissions = commissionOptions.data.commissions.find(
        (x) =>
          x.id === bankIdCommissionIdWithInstallment[1] && !x.isVisaMasterCard
      );
      installmentCount = bankIdCommissionIdWithInstallment[3];
    }
    if (
      (bankIdCommissionIdWithInstallment &&
        emailRequiredBankIds?.includes(bankIdCommissionIdWithInstallment[0])) ||
      allValues.bankId === 856 ||
      allValues.bankId === 855
    ) {
      setEmailRequired(true);
      form.setFieldsValue({ email: localStorage.getItem("email") });
    } else {
      setEmailRequired(false);
    }

    setActiveBankId(allValues.bankId);

    if (!activeCommissions) {
      setPayableAmount(
        calculatePayableAmount(allValues.amount, 0, allValues.bankId, false)
      );

      setActiveCommissionRate(0);
      return;
    }

    const commissionRate =
      activeCommissions["commissionRate" + installmentCount];
    if (!(allValues.amount > 0 && commissionRate >= 0)) {
      setPayableAmount(
        calculatePayableAmount(allValues.amount, 0, allValues.bankId, false)
      );
      setActiveCommissionRate(commissionRate);
      return;
    }

    setPayableAmount(
      calculatePayableAmount(
        allValues.amount,
        commissionRate,
        allValues.bankId,
        activeCommissions["isCommissionFromDealer"]
      )
    );
    setActiveCommissionRate(commissionRate);
  };
  const calculatePayableAmount = (
    amount,
    commissionRate,
    bankId,
    isCommissionFromDealer
  ) => {
    const { useCommissionsForAvailableInstallment } = commissionOptions.data;
    let payableAmount = amount;
    if (useCommissionsForAvailableInstallment) {
      payableAmount = amount + (amount / 100) * commissionRate;
    }

    if (isCommissionFromDealer && useCommissionsForAvailableInstallment) {
      payableAmount = (amount / (100 - commissionRate)) * 100;
    }

    if (bankId == 856) {
      payableAmount = amount / ((100 - commissionRate) / 100);
    }

    return payableAmount;
  };

  const isExternalPaymentFormProvider = false;

  const handleCardNumberChange = (e) => {
    if (!isUseCreditCardBinCheck) {
      return;
    }

    const inputValue = e.target.rawValue;

    if (inputValue.length <= 8) {
      setRequestBin(true);
    }

    if ((inputValue.length === 8 || inputValue.length === 16) && requestBin) {
      RequestHandler.post(
        `/PosCollection/CreditCardBinCheck`,
        {
          cardNumber: inputValue,
        },
        false
      ).then((response) => {
        if (response?.success) {
          setRequestBin(false);
          setBankIdFromBinCheckResult(response.data.bankId);
          setCardKindFromBinCheckResult(response.data.cardKind);
          getCommissionOptions(
            activeFirmId,
            response.data.bankId,
            response.data.cardKind,
            form.getFieldValue("amount"),
            selectedPaymentMethod?.paymentSetId
          );
        } else {
          getCommissionOptions();
        }
      });
    }
  };

  useEffect(() => {
    if (commissionOptions.data.commissions.length > 0) {
      let bankIdFromBinCheck = bankIdFromBinCheckResult;
      let queryString = bankIdFromBinCheck
        ? "?bankIdFromBinCheck=" + bankIdFromBinCheck
        : "";
      const bankIdsFromCommissions = [
        ...new Set(
          commissionOptions.data.commissions.map((item) => item.bankId)
        ),
      ];

      RequestHandler.get(
        `/PosCollection/AvailableProviders${queryString}`
      ).then((response) => {
        if (response.success) {
          if (response.data.length < 1) {
            setAvailableProviders({
              data: bankIdsFromCommissions,
              loading: false,
            });
          } else {
            const filterWithCommissionBankIds = response.data.filter((x) =>
              bankIdsFromCommissions.includes(x.id)
            );
            setAvailableProviders({
              data: filterWithCommissionBankIds,
              loading: false,
            });
            setActiveProviderId(filterWithCommissionBankIds?.at(0)?.id);

            if (filterWithCommissionBankIds?.at(0)?.id) {
              getAvailableInstallments(
                filterWithCommissionBankIds?.at(0)?.id,
                activeFirmId,
                commissionOptions.data.commissions
              );
            }
          }
        } else {
          setAvailableProviders({ ...availableProviders, loading: false });
        }
      });
    }
  }, [commissionOptions]);

  useEffect(() => {
    if (availableProviders.data.length > 0) {
      const initialValue = availableProviders.data[0].id;
      onChangeActiveProvider(initialValue);
      setFieldsValue({ bankId: initialValue });
    }
  }, [availableProviders]);

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  const handleAmountInputBlur = (e) => {
    if (
      !(isUseCreditCardBinCheck && bankIdFromBinCheckResult === null) &&
      typeof activeAmount === "number"
    ) {
      getCommissionOptions(
        activeFirmId,
        bankIdFromBinCheckResult,
        cardKindFromBinCheckResult,
        activeAmount,
        selectedPaymentMethod?.paymentSetId
      );
    }
  };

  useEffect(() => {
    if (isUseB2BCurrencyExChange && typeof activeAmount === "number") {
      RequestHandler.post(
        `/PosCollection/GetPosCollectionTransactionExchangeAmounts`,
        {
          amount: activeAmount,
          currencyCode: activeCurrency,
        },
        false
      ).then((response) => {
        if (response?.success) {
          setCurrencyExchangeRates({
            data: {
              usdAmount: response.data.usdAmount,
              euroAmount: response.data.euroAmount,
              tlAmount: response.data.tlAmount,
            },
          });
        }
      });
    }
  }, [activeCurrency]);

  const handleAmountChange = () => {
    if (isUseB2BCurrencyExChange && typeof activeAmount === "number") {
      RequestHandler.post(
        `/PosCollection/GetPosCollectionTransactionExchangeAmounts`,
        {
          amount: activeAmount,
          currencyCode: activeCurrency,
        },
        false
      ).then((response) => {
        if (response?.success) {
          setCurrencyExchangeRates({
            data: {
              usdAmount: response.data.usdAmount,
              euroAmount: response.data.euroAmount,
              tlAmount: response.data.tlAmount,
            },
          });
        }
      });
    }
  };

  const combinedBlurFunctionForAmount = (e) => {
    handleAmountInputBlur(e);
    handleAmountChange();
  };

  const getTenantScreenSettings = () => {
    RequestHandler.get("/PosCollection/TenantScreenSettings/1").then(
      (response) => {
        if (response.success) {
          setTenantScreenSettings(response.data);
        } else {
          setTenantScreenSettings(...tenantScreenSettings);
        }
      }
    );
  };

  return (
    <>
      <div style={{ maxWidth: "85%", margin: "4px auto 8px" }}>
        <BannerSlider
          screenName="PosCollection"
          controlParameter={false}
          isLogin={false}
          firmId={activeFirmId}
          closable
        />
      </div>
      <Row id="titleArea">
        <Col xs={24} md={12} lg={16}>
          <h1 style={{ marginBottom: 0 }}>
            <BarsOutlined /> Pos Tahsilatı
          </h1>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}></Col>
      </Row>

      <Divider style={{ margin: "12px 0" }} />

      <Row id="paymentArea" justify="center" align="middle">
        <Col span={24}>
          <Card className="gx-card" loading={availableProviders.loading}>
            {availableProviders.data.length > 0 ? (
              <Form
                {...formItemLayout}
                validateMessages={defaultValidateMessages}
                form={form}
                name="PaymentForm"
                initialValues={{
                  remember: true,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                labelAlign="left"
                onValuesChange={onFormValuesChange}
                fields={[
                  { name: "firmId", value: activeFirmId },
                  { name: "payableAmount", value: payableAmount },
                ]}
              >
                {commissionOptions.data.isSelectableInstallmentTable ||
                commissionOptionsForBinCheckUsage.data
                  .isSelectableInstallmentTable ? (
                  <>
                    <Row justify="center">
                      <Col xs={24} lg={12}>
                        <Form.Item
                          label="Bayi"
                          name="firmId"
                          rules={[
                            {
                              required:
                                tenantScreenSettings.b2BFirmSelectRequired,
                            },
                          ]}
                        >
                          <Select
                            allowClear
                            showSearch
                            placeholder="Seçiniz"
                            onSearch={onFirmSearch}
                            filterOption={(input, option) =>
                              option.children
                                .toLocaleLowerCase("tr-TR")
                                .indexOf(input.toLocaleLowerCase("tr-TR")) >=
                                0 ||
                              option.code
                                .toLocaleLowerCase("tr-TR")
                                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                            }
                            loading={firmSelect.loading}
                            onChange={(value, option) => {
                              setActiveFirmId(value ?? null);

                              const firm = firmsBalance.data.find(
                                (x) => x.code === option?.code
                              );
                              const balance =
                                firm?.balance > 0 ? firm.balance : undefined;

                              setActiveFirmBalance(balance);
                              setFieldsValue({ amount: balance });
                              setActiveAmount(balance);
                            }}
                          >
                            {firmSelect.data.map((item) => (
                              <Select.Option
                                key={item.id}
                                value={item.id}
                                code={item.firmBranchNumber}
                              >
                                {`${item.name} (${item.firmBranchNumber})`}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row justify="center">
                      <Col
                        xs={
                          tenantScreenSettings.b2BMobilePhoneVisibility
                            ? 12
                            : 24
                        }
                        lg={
                          tenantScreenSettings.b2BMobilePhoneVisibility ? 6 : 12
                        }
                        hidden={
                          !tenantScreenSettings.b2BCustomerInformationVisibility
                        }
                      >
                        <Form.Item
                          label="Müşteri Bilgisi"
                          name="customerInformation"
                        >
                          <Input allowClear />
                        </Form.Item>
                      </Col>

                      <Col
                        xs={12}
                        lg={6}
                        hidden={!tenantScreenSettings.b2BMobilePhoneVisibility}
                      >
                        <Form.Item
                          label="Cep Numarası"
                          name="mobilePhone"
                          rules={[
                            {
                              min: 12,
                              message: "Telefon numarasını eksiksiz giriniz.",
                            },
                          ]}
                        >
                          <PhoneInput
                            inputStyle={{ width: "100%" }}
                            country="tr"
                            masks={{ tr: "(...) ...-..-.." }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row justify="center">
                      <Col xs={12} lg={6}>
                        <Form.Item
                          label="Tutar"
                          name="amount"
                          rules={[{ required: true }]}
                        >
                          <InputNumber
                            style={{ width: "100%" }}
                            decimalSeparator=","
                            precision={2}
                            min={0}
                            placeholder="0,00"
                            onChange={(value) => {
                              setActiveAmount(value);
                              form.setFieldsValue({ amount: value }); // Form değerini manuel olarak güncelle
                            }}
                            onBlur={combinedBlurFunctionForAmount}
                          />
                        </Form.Item>
                        <div style={{ marginTop: "10px", marginLeft: "5%" }}>
                          {currencyExchangeRates.data.usdAmount &&
                          currencyExchangeRates.data.euroAmount ? (
                            <div style={{ color: "#0047ca" }}>
                              {currencyExchangeRates.data.usdAmount} /{" "}
                              {currencyExchangeRates.data.euroAmount}
                            </div>
                          ) : currencyExchangeRates.data.euroAmount ? (
                            <div style={{ color: "#0047ca" }}>
                              {currencyExchangeRates.data.euroAmount}
                            </div>
                          ) : currencyExchangeRates.data.usdAmount ? (
                            <div style={{ color: "#0047ca" }}>
                              {currencyExchangeRates.data.usdAmount}
                            </div>
                          ) : null}
                        </div>

                        {currencyExchangeRates.data.tlAmount && (
                          <div style={{ marginTop: "10px", marginLeft: "5%" }}>
                            <div style={{ color: "#0047ca" }}>
                              {currencyExchangeRates.data.tlAmount}
                            </div>
                          </div>
                        )}

                        <div style={{ marginTop: "5px", marginLeft: "5%" }}>
                          {isUseB2BViewCurrencyExchangeRate ? (
                            <div style={{ color: "#0047ca" }}>
                              {"USD Kur : " +
                                ColumnHelper.renderDecimal(
                                  viewCurrencyExchangeRates.data?.usd
                                )}
                            </div>
                          ) : null}
                        </div>
                        <div style={{ marginTop: "5px", marginLeft: "5%" }}>
                          {isUseB2BViewCurrencyExchangeRate ? (
                            <div style={{ color: "#0047ca" }}>
                              {"EURO Kur : " +
                                ColumnHelper.renderDecimal(
                                  viewCurrencyExchangeRates.data?.euro
                                )}
                            </div>
                          ) : null}
                        </div>
                      </Col>

                      <Col xs={12} lg={6}>
                        <Form.Item
                          label="Para Birimi"
                          name="currencyCode"
                          initialValue={currencyCodes[0]}
                        >
                          <Select
                            onChange={(value) => {
                              setActiveCurrency(value);
                            }}
                          >
                            {currencyCodes.map((currencyCode) => (
                              <Select.Option
                                key={currencyCode}
                                value={currencyCode}
                              >
                                {currencyCode}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>

                    {useAdditionalInformation ? (
                      // useAdditionalInformation true olduğunda mevcut düzen
                      <>
                        <Divider>Ek Bilgiler</Divider>

                        <Row justify="center">
                          <Col xs={9} lg={6}>
                            <Form.Item
                              label="TC Kimlik Numarası"
                              name="tckn"
                              rules={[
                                {
                                  required: true,
                                  min: 11,
                                  message:
                                    "TC Kimlik Numarası 11 Karakter Olmalıdır.",
                                },
                              ]}
                            >
                              <Input
                                placeholder="TC Kimlik Numarası"
                                type="number"
                                onKeyDown={(evt) =>
                                  evt.key === "e" && evt.preventDefault()
                                }
                                maxLength="11"
                                onInput={maxLengthCheck}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={15} lg={6}>
                            <Form.Item
                              label="Sözleşme Numarası"
                              name="contractNumber"
                              rules={[
                                {
                                  required: true,
                                  min: 6,
                                  message:
                                    "Sözleşme numarası 6 Karakter Olmalıdır.",
                                },
                              ]}
                            >
                              <Input
                                placeholder="Sözleşme Numarası"
                                type="number"
                                maxLength="6"
                                onInput={maxLengthCheck}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row justify="center">
                          <Col xs={15} lg={6}>
                            <Form.Item
                              label="Şube Adı/Kodu"
                              name="branchCode"
                              rules={[{ required: true }]}
                            >
                              <Input
                                placeholder="Şube Adı/Kodu"
                                maxLength="50"
                                onInput={maxLengthCheck}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={9} lg={6}>
                            <Form.Item label="Ek Alan" name="memberNumber">
                              <Input placeholder="Ek Alan" />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row justify="center">
                          <Col xs={15} lg={6}>
                            <Form.Item
                              label="Ödeme Şekli"
                              name="paymentMethod"
                              rules={[
                                {
                                  required: true,
                                },
                              ]}
                            >
                              <Select
                                allowClear
                                placeholder="Ödeme Şekli"
                                onChange={(value, option) => {
                                  setSelectedPaymentMethod(option);
                                }}
                              >
                                {paymentMethodList.data.map((item) => (
                                  <Select.Option
                                    key={item.id}
                                    value={item.id}
                                    name={item.name}
                                    paymentSetId={item.paymentSetId}
                                  >
                                    {`${item.name}`}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={9} lg={6}></Col>
                        </Row>
                      </>
                    ) : tenantScreenSettings.b2BTcknVisibility ? (
                      // useAdditionalInformation false ve tenantScreenSettings.b2BTcknVisibility true olduğunda sadece TCKN göster
                      <>
                        <Divider>Ek Bilgiler</Divider>
                        <Row justify="center">
                          <Col xs={12} lg={6}>
                            <Form.Item
                              label="TC Kimlik Numarası"
                              name="tckn"
                              rules={[
                                {
                                  min: 11,
                                  message:
                                    "TC Kimlik Numarası 11 Karakter Olmalıdır.",
                                },
                              ]}
                            >
                              <Input
                                placeholder="TC Kimlik Numarası"
                                type="number"
                                onKeyDown={(evt) =>
                                  evt.key === "e" && evt.preventDefault()
                                }
                                maxLength="11"
                                onInput={maxLengthCheck}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={12} lg={6}></Col>
                        </Row>
                      </>
                    ) : null}

                    <Divider>Kart Bilgileri</Divider>

                    <Row justify="center">
                      <Col xs={24} lg={12}>
                        <Form.Item
                          label="Kart Üzerindeki İsim"
                          name="holderName"
                          rules={[{ required: true }]}
                        >
                          <Input placeholder="Ad Soyad" />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row justify="center">
                      <Col xs={24} lg={12}>
                        <Form.Item
                          label="Kart Numarası"
                          name="cardNumber"
                          id="cardNumber"
                          valuePropName="rawValue"
                          rules={[
                            { required: true },
                            {
                              min: 15,
                              max: 16,
                            },
                          ]}
                        >
                          <Cleave
                            className="ant-input"
                            placeholder="0000 0000 0000 0000"
                            options={{
                              creditCard: true,
                              onCreditCardTypeChanged: (type) =>
                                setCreditCardType(type),
                            }}
                            onChange={handleCardNumberChange}
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row justify="center">
                      <Col xs={15} lg={6}>
                        <Form.Item
                          label="Son Kullanma Tarihi"
                          name="expiration"
                          rules={[{ required: true }]}
                        >
                          <Cleave
                            className="ant-input"
                            placeholder="AA/YY"
                            options={{
                              date: true,
                              datePattern: ["m", "y"],
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={9} lg={6} style={{ paddingLeft: "0px" }}>
                        <Form.Item
                          label="Güvenlik Kodu"
                          name="cvv"
                          rules={[{ required: true }]}
                        >
                          <Cleave
                            className="ant-input"
                            placeholder="CVV"
                            options={{
                              blocks: [4],
                              numericOnly: true,
                            }}
                            type="password"
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row justify="center">
                      <Col xs={24} sm={12} lg={6}>
                        <Form.Item label="Açıklama" name="description">
                          <TextArea rows={4} allowClear />
                        </Form.Item>
                      </Col>

                      <Col
                        xs={24}
                        sm={12}
                        lg={6}
                        style={{ paddingLeft: "0px" }}
                        hidden={!emailRequired}
                      >
                        <Form.Item
                          label="Email"
                          name="email"
                          rules={[{ required: emailRequired, type: "email" }]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col xs={0} sm={0} lg={6} hidden={emailRequired}></Col>
                    </Row>

                    {isExternalPaymentFormProvider &&
                      commissionOptions.data.posCollectionDescription && (
                        <Row
                          id="descriptionArea"
                          style={{ marginBottom: 12 }}
                          justify="center"
                        >
                          <Col xs={24} lg={12}>
                            <div
                              dangerouslySetInnerHTML={{
                                __html:
                                  commissionOptions.data
                                    .posCollectionDescription,
                              }}
                            />
                          </Col>
                        </Row>
                      )}

                    {!isExternalPaymentFormProvider && (
                      <>
                        <Row justify="center">
                          <Col xs={24} lg={12}>
                            <PosSelectableInstallmentTable
                              data={commissionOptions.data}
                              amount={activeAmount}
                              loading={commissionOptions.loading}
                              onChange={onChangeRadio}
                              radioValue={radioValue}
                              filePath={b2bFilePath}
                              campaignButtonVisibility={
                                tenantScreenSettings.b2BShowCampaignButton
                              }
                            />
                          </Col>
                        </Row>

                        {commissionOptions.data.posCollectionDescription && (
                          <Row
                            id="descriptionArea"
                            style={{ marginBottom: 12 }}
                            justify="center"
                          >
                            <Col xs={24} lg={12}>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html:
                                    commissionOptions.data
                                      .posCollectionDescription,
                                }}
                              />
                            </Col>
                          </Row>
                        )}
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {!isExternalPaymentFormProvider && (
                      <>
                        <Row justify="center">
                          <Col xs={24} lg={12}>
                            <Form.Item
                              label="Bayi"
                              name="firmId"
                              rules={[
                                {
                                  required:
                                    tenantScreenSettings.b2BFirmSelectRequired,
                                },
                              ]}
                            >
                              <Select
                                allowClear
                                showSearch
                                placeholder="Seçiniz"
                                onSearch={onFirmSearch}
                                filterOption={(input, option) =>
                                  option.children
                                    .toLocaleLowerCase("tr-TR")
                                    .indexOf(
                                      input.toLocaleLowerCase("tr-TR")
                                    ) >= 0 ||
                                  option.code
                                    .toLocaleLowerCase("tr-TR")
                                    .indexOf(
                                      input.toLocaleLowerCase("tr-TR")
                                    ) >= 0
                                }
                                loading={firmSelect.loading}
                                onChange={(value, option) => {
                                  setActiveFirmId(value ?? null);

                                  const firm = firmsBalance.data.find(
                                    (x) => x.code === option?.code
                                  );
                                  const balance =
                                    firm?.balance > 0
                                      ? firm.balance
                                      : undefined;

                                  setActiveFirmBalance(balance);
                                  setFieldsValue({ amount: balance });
                                  setActiveAmount(balance);
                                }}
                              >
                                {firmSelect.data.map((item) => (
                                  <Select.Option
                                    key={item.id}
                                    value={item.id}
                                    code={item.firmBranchNumber}
                                  >
                                    {`${item.name} (${item.firmBranchNumber})`}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                        </Row>

                        {useAdditionalInformation ? (
                          <>
                            <Divider>Ek Bilgiler</Divider>

                            <Row justify="center">
                              <Col xs={9} lg={6}>
                                <Form.Item
                                  label="TC Kimlik Numarası"
                                  name="tckn"
                                  rules={[
                                    {
                                      required: true,
                                      min: 11,
                                      message:
                                        "TC Kimlik Numarası 11 Karakter Olmalıdır.",
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder="TC Kimlik Numarası"
                                    type="number"
                                    onKeyDown={(evt) =>
                                      evt.key === "e" && evt.preventDefault()
                                    }
                                    maxLength="11"
                                    onInput={maxLengthCheck}
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={15} lg={6}>
                                <Form.Item
                                  label="Sözleşme Numarası"
                                  name="contractNumber"
                                  rules={[
                                    {
                                      required: true,
                                      min: 6,
                                      message:
                                        "Sözleşme numarası 6 Karakter Olmalıdır.",
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder="Sözleşme Numarası"
                                    type="number"
                                    maxLength="6"
                                    onInput={maxLengthCheck}
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                            <Row justify="center">
                              <Col xs={15} lg={6}>
                                <Form.Item
                                  label="Şube Kodu"
                                  name="branchCode"
                                  rules={[{ required: true }]}
                                >
                                  <Input
                                    placeholder="Şube Kodu"
                                    maxLength="50"
                                    onInput={maxLengthCheck}
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={9} lg={6}>
                                <Form.Item
                                  label="Ek Alan"
                                  name="memberNumber"
                                  rules={[
                                    {
                                      required: true,
                                    },
                                  ]}
                                >
                                  <Input placeholder="Ek Alan" />
                                </Form.Item>
                              </Col>
                            </Row>
                            <Row justify="center">
                              <Col xs={15} lg={6}>
                                <Form.Item
                                  label="Ödeme Şekli"
                                  name="paymentMethod"
                                  rules={[
                                    {
                                      required: true,
                                    },
                                  ]}
                                >
                                  <Select
                                    allowClear
                                    placeholder="Ödeme Şekli"
                                    onChange={(value, option) => {
                                      setSelectedPaymentMethod(option);
                                    }}
                                  >
                                    {paymentMethodList.data.map((item) => (
                                      <Select.Option
                                        key={item.id}
                                        value={item.id}
                                        name={item.name}
                                        paymentSetId={item.paymentSetId}
                                      >
                                        {`${item.name}`}
                                      </Select.Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </Col>
                              <Col xs={9} lg={6}></Col>
                            </Row>
                          </>
                        ) : tenantScreenSettings.b2BTcknVisibility ? (
                          // useAdditionalInformation false ve tenantScreenSettings.b2BTcknVisibility true olduğunda sadece TCKN göster
                          <>
                            <Divider>Ek Bilgiler</Divider>
                            <Row justify="center">
                              <Col xs={12} lg={6}>
                                <Form.Item
                                  label="TC Kimlik Numarası"
                                  name="tckn"
                                  rules={[
                                    {
                                      min: 11,
                                      message:
                                        "TC Kimlik Numarası 11 Karakter Olmalıdır.",
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder="TC Kimlik Numarası"
                                    type="number"
                                    onKeyDown={(evt) =>
                                      evt.key === "e" && evt.preventDefault()
                                    }
                                    maxLength="11"
                                    onInput={maxLengthCheck}
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={12} lg={6}></Col>
                            </Row>
                          </>
                        ) : null}

                        <Row justify="center">
                          <Col
                            xs={
                              tenantScreenSettings.b2BMobilePhoneVisibility
                                ? 12
                                : 24
                            }
                            lg={
                              tenantScreenSettings.b2BMobilePhoneVisibility
                                ? 6
                                : 12
                            }
                            hidden={
                              !tenantScreenSettings.b2BCustomerInformationVisibility
                            }
                          >
                            <Form.Item
                              label="Müşteri Bilgisi"
                              name="customerInformation"
                            >
                              <Input allowClear />
                            </Form.Item>
                          </Col>

                          <Col
                            xs={12}
                            lg={6}
                            hidden={
                              !tenantScreenSettings.b2BMobilePhoneVisibility
                            }
                          >
                            <Form.Item
                              label="Cep Numarası"
                              name="mobilePhone"
                              rules={[
                                {
                                  min: 12,
                                  message:
                                    "Telefon numarasını eksiksiz giriniz.",
                                },
                              ]}
                            >
                              <PhoneInput
                                inputStyle={{ width: "100%" }}
                                country="tr"
                                masks={{ tr: "(...) ...-..-.." }}
                              />
                            </Form.Item>
                          </Col>
                        </Row>

                        <Divider>Kart Bilgileri</Divider>

                        <Row justify="center">
                          <Col xs={24} lg={12}>
                            <Form.Item
                              label="Kart Üzerindeki İsim"
                              name="holderName"
                              rules={[{ required: true }]}
                            >
                              <Input placeholder="Ad Soyad" />
                            </Form.Item>
                          </Col>
                        </Row>

                        <Row justify="center">
                          <Col xs={24} lg={12}>
                            <Form.Item
                              label="Kart Numarası"
                              name="cardNumber"
                              valuePropName="rawValue"
                              rules={[
                                { required: true },
                                {
                                  min: 15,
                                  max: 16,
                                },
                              ]}
                            >
                              <Cleave
                                className="ant-input"
                                placeholder="0000 0000 0000 0000"
                                options={{
                                  creditCard: true,
                                  onCreditCardTypeChanged: (type) =>
                                    setCreditCardType(type),
                                }}
                                onChange={handleCardNumberChange}
                              />
                            </Form.Item>
                          </Col>
                        </Row>

                        <Row justify="center">
                          <Col xs={15} lg={6}>
                            <Form.Item
                              label="Son Kullanma Tarihi"
                              name="expiration"
                              rules={[{ required: true }]}
                            >
                              <Cleave
                                className="ant-input"
                                placeholder="AA/YY"
                                options={{
                                  date: true,
                                  datePattern: ["m", "y"],
                                }}
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={9} lg={6} style={{ paddingLeft: "0px" }}>
                            <Form.Item
                              label="Güvenlik Kodu"
                              name="cvv"
                              rules={[{ required: true }]}
                            >
                              <Cleave
                                className="ant-input"
                                placeholder="CVV"
                                options={{
                                  blocks: [4],
                                  numericOnly: true,
                                }}
                                type="password"
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row justify="center">
                          <Col xs={24} sm={12} lg={6}>
                            <Form.Item label="Açıklama" name="description">
                              <TextArea rows={4} allowClear />
                            </Form.Item>
                          </Col>

                          <Col
                            xs={24}
                            sm={12}
                            lg={6}
                            style={{ paddingLeft: "0px" }}
                            hidden={!emailRequired}
                          >
                            <Form.Item
                              label="Email"
                              name="email"
                              rules={[
                                { required: emailRequired, type: "email" },
                              ]}
                            >
                              <Input />
                            </Form.Item>
                          </Col>
                          <Col
                            xs={0}
                            sm={0}
                            lg={6}
                            hidden={emailRequired}
                          ></Col>
                        </Row>
                      </>
                    )}
                    <Divider>Ödeme Bilgileri</Divider>

                    <Row justify="center">
                      <Col xs={24} lg={12}>
                        <Form.Item
                          id="bankId"
                          label="Ödeme Sağlayıcı"
                          name="bankId"
                          hidden={
                            isUseCreditCardBinCheck
                              ? false
                              : availableProviders.data?.length === 1
                          }
                          rules={[
                            {
                              required: true,
                              message:
                                "Ödeme Sağlayıcısı seçmeniz gerekmektedir.",
                            },
                          ]}
                          initialValue={availableProviders.data?.at(0).id}
                        >
                          <Select
                            onChange={(value) => onChangeActiveProvider(value)}
                            disabled={
                              isUseCreditCardBinCheck &&
                              commissionOptions.data.commissions.length === 0
                            }
                            defaultValue={availableProviders.data?.at(0).id}
                          >
                            {availableProviders.data?.map((item) => (
                              <Select.Option key={item.id} value={item.id}>
                                {item.name}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row justify="center">
                      <Col xs={24} lg={4}>
                        <Form.Item
                          label="Tutar"
                          name="amount"
                          rules={[
                            {
                              required: true,
                            },
                          ]}
                        >
                          <InputNumber
                            style={{ width: "100%" }}
                            decimalSeparator=","
                            precision={2}
                            min={0}
                            placeholder="0,00"
                            onChange={(value) => {
                              setActiveAmount(value);
                              form.setFieldsValue({ amount: value }); // Form değerini manuel olarak güncelle
                            }}
                            onBlur={combinedBlurFunctionForAmount}
                          />
                        </Form.Item>
                        {currencyExchangeRates.data.euroAmount && (
                          <div style={{ marginTop: "10px", marginLeft: "3%" }}>
                            <div style={{ color: "#0047ca" }}>
                              {currencyExchangeRates.data.usdAmount} /{" "}
                              {currencyExchangeRates.data.euroAmount}
                            </div>
                          </div>
                        )}
                        {currencyExchangeRates.data.tlAmount && (
                          <div style={{ marginTop: "10px", marginLeft: "3%" }}>
                            <div style={{ color: "#0047ca" }}>
                              {currencyExchangeRates.data.tlAmount}
                            </div>
                          </div>
                        )}
                      </Col>

                      <Col xs={24} lg={4}>
                        <Form.Item
                          label="Para Birimi"
                          name="currencyCode"
                          initialValue={currencyCodes[0]}
                        >
                          <Select
                            onChange={(value) => {
                              setActiveCurrency(value);
                            }}
                          >
                            {currencyCodes.map((currencyCode) => (
                              <Select.Option
                                key={currencyCode}
                                value={currencyCode}
                              >
                                {currencyCode}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>

                      {!isExternalPaymentFormProvider && (
                        <Col xs={24} lg={4}>
                          <Form.Item
                            label="Taksit"
                            name="installmentCount"
                            initialValue={availableInstallments.data?.at(0)}
                          >
                            <Select
                              loading={availableInstallments.loading}
                              disabled={availableInstallments.loading}
                            >
                              {availableInstallments?.data?.map(
                                (installment) => (
                                  <Select.Option
                                    key={installment}
                                    value={installment}
                                  >
                                    {installment === 1
                                      ? "Tek Çekim"
                                      : `${installment} Taksit`}
                                  </Select.Option>
                                )
                              )}
                            </Select>
                          </Form.Item>
                        </Col>
                      )}
                    </Row>
                    {commissionOptions.data.posCollectionDescription && (
                      <Row
                        id="descriptionArea"
                        style={{ marginBottom: 12 }}
                        justify="center"
                      >
                        <Col xs={24} lg={12}>
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                commissionOptions.data.posCollectionDescription,
                            }}
                          />
                        </Col>
                      </Row>
                    )}
                  </>
                )}

                <PosCollectionAmountSummary
                  payableAmount={payableAmount}
                  activeAmount={activeAmount}
                  commissionRate={activeCommissionRate}
                />
                <Row justify="center">
                  <Col
                    xs={24}
                    lg={preAuthBankIds.includes(activeBankId) ? 6 : 8}
                  >
                    <Form.Item
                      name="agreement"
                      valuePropName="checked"
                      rules={[
                        {
                          required: true,
                          message: "Sözleşmeleri kabul etmeniz gerekmektedir.",
                        },
                      ]}
                    >
                      <Checkbox>
                        <a href={confidentialAgreement} target="_blank">
                          Gizlilik
                        </a>{" "}
                        ve{" "}
                        <a href={salesAgreement} target="_blank">
                          Tüketici Hakları
                        </a>{" "}
                        sözleşmelerini okudum, onaylıyorum.
                      </Checkbox>
                    </Form.Item>
                  </Col>

                  <Col
                    xs={24}
                    lg={preAuthBankIds.includes(activeBankId) ? 6 : 4}
                    style={{ textAlign: "right" }}
                  >
                    <Space>
                      {preAuthBankIds.includes(activeBankId) && (
                        <Button
                          type="primary"
                          htmlType="submit"
                          onClick={() => {
                            setIsUsePreAuth(true);
                            setLoading(true);
                          }}
                          loading={loading}
                        >
                          {payableAmount > 0
                            ? `(${ColumnHelper.renderDecimal(payableAmount)}) `
                            : undefined}
                          Provizyon ile Öde
                        </Button>
                      )}
                      <Button
                        type="primary"
                        htmlType="submit"
                        onClick={() => {
                          setIsUsePreAuth(false);
                          setLoading(true);
                        }}
                        loading={loading}
                      >
                        {payableAmount > 0
                          ? `(${ColumnHelper.renderDecimal(payableAmount)}) `
                          : undefined}
                        Öde
                      </Button>
                    </Space>
                  </Col>
                </Row>
              </Form>
            ) : (
              "Firmanızın tanımlı bir ödeme sağlayıcısı bulunmuyor."
            )}
          </Card>
        </Col>
      </Row>

      {!usePosCommissionTable &&
        !commissionOptions.loading &&
        !commissionOptions.data.isSelectableInstallmentTable &&
        commissionOptions.data.commissions.length > 0 && (
          <PosCommissionTable
            data={commissionOptions.data}
            amount={activeAmount}
            loading={commissionOptions.loading}
          />
        )}

      {usePosCommissionTable && (
        <PosCommissionTable
          data={commissionOptionsForBinCheckUsage.data}
          amount={activeAmount}
          loading={commissionOptionsForBinCheckUsage.loading}
        />
      )}

      <Modal
        id="paymentModal"
        centered
        visible={paymentModal.visible}
        onCancel={() => {
          setPaymentModal({ ...paymentModal, visible: false });
          setUrlIframe(false);
        }}
        destroyOnClose={false}
        maskClosable={false}
        keyboard={false}
        width={600}
        footer={null}
      >
        {urlIframe ? (
          <iframe
            id="paymentFrame"
            ref={iframeRef}
            style={{ width: "100%", border: 0 }}
            src={paymentModal.source}
            scrolling="auto"
            onLoad={() => {
              const iframe = iframeRef.current;
              iframe.style.height = iframe.scrollWidth + 150 + "px";
            }}
          />
        ) : (
          <iframe
            id="paymentFrame"
            ref={iframeRef}
            style={{ width: "100%", border: 0 }}
            srcDoc={paymentModal.source}
            sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
            scrolling="auto"
            onLoad={() => {
              const iframe = iframeRef.current;
              iframe.style.height = iframe.scrollWidth + 150 + "px";
            }}
          />
        )}
      </Modal>
    </>
  );
};

export default PosCollectionPage;
